import { render, staticRenderFns } from "./artistsSelect.vue?vue&type=template&id=5b70cee2&scoped=true"
import script from "./artistsSelect.vue?vue&type=script&lang=js"
export * from "./artistsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70cee2",
  null
  
)

export default component.exports